import { useState } from 'react'
import { Img, Modal, ModalBody, ModalCloseButton, Text, VStack, Button, Box } from '@chakra-ui/react'
import survey from 'assets/images/survey.png'
import FeedbackModal from 'components/LeftSidebar/components/FeedbackModal'
import { useStores } from 'hooks/useStores'
import { observer } from 'mobx-react'
import { primary } from 'theme/globalStyles'

interface ISurveyPopupProps {
  isOpen: boolean
  onClose: () => void
}

const SurveyPopup = (props: ISurveyPopupProps) => {
  const { isOpen, onClose } = props
  const { organizationStore } = useStores()
  const { organization } = organizationStore
  const currentTheme = organization?.theme ?? {}
  const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false)

  return (
    <Modal isOpen={isOpen} onClose={() => {}}>
      <Box
        width="224px"
        height="264px"
        background="gray.50"
        borderRadius="16px"
        margin="0"
        position="fixed"
        bottom="6"
        right="10"
        boxShadow="0px 10px 15px -3px rgba(0, 0, 0, 0.10), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)"
      >
        <ModalCloseButton onClick={onClose} />
        <ModalBody paddingX={5} paddingBottom={5} paddingTop={4}>
          <VStack width="full" align="flex-start" flexShrink={0}>
            <Img boxSize="80px" src={survey} />
            <Text color="gray.900" fontSize="16px" fontWeight={600} lineHeight={6}>
              Help us improve our product for you
            </Text>
          </VStack>
          <VStack width="full" marginTop={4}>
            <Button
              size="sm"
              width="full"
              type="submit"
              border="0"
              color="white"
              fontSize="16px"
              fontWeight={500}
              lineHeight={6}
              background={currentTheme?.primaryColor ?? primary}
              _hover={{ opacity: 0.8 }}
              onClick={() => setShowFeedbackModal(true)}
            >
              Give feedback
            </Button>
            <Button
              size="sm"
              width="full"
              color="gray.700"
              background="white"
              fontSize="16px"
              fontWeight={500}
              lineHeight={6}
              border="1px solid #E2E8F0"
              onClick={onClose}
            >
              Remind me later
            </Button>
          </VStack>
        </ModalBody>
      </Box>
      <FeedbackModal isOpen={showFeedbackModal} onClose={() => setShowFeedbackModal(false)} />
    </Modal>
  )
}

export default observer(SurveyPopup)
